/* eslint-disable class-methods-use-this,no-underscore-dangle */

import { EVENTS } from '../../../../app/constants/events';

// eslint-disable-next-line no-var
var OnbordingToolbar = class OnbordingToolbar {
  constructor($element, $translate, $state, $rootScope, $scope, $timeout, notify, Subscription) {
    this._$element = $element;
    this._$translate = $translate;
    this._$state = $state;
    this._$rootScope = $rootScope;
    this._$scope = $scope;
    this._$timeout = $timeout;
    this.Subscription = Subscription;
    this.notify = notify;
    this._lastCompletedStepsCount = 0;
    this.days = 0;
    this.completed = false;

    this.steps = [
      {
        key: 'create_connection',
        index: '01',
        text: $translate.instant('onboarding-toolbar.step-1'),
        completed: false,
        state: 'app.account.connections.new',
      },
      {
        key: 'create_valid_package',
        index: '02',
        text: $translate.instant('onboarding-toolbar.step-2'),
        completed: false,
        state: 'app.account.packages.new',
      },
      {
        key: 'execute_successful_job',
        index: '03',
        text: $translate.instant('onboarding-toolbar.step-3'),
        completed: false,
        state: 'app.account.jobs.new',
      },
      {
        key: 'create_schedule',
        index: '04',
        text: $translate.instant('onboarding-toolbar.step-4'),
        completed: false,
        state: 'app.account.schedules.new',
      },
    ];
  }

  $onInit() {
    this.user = this._$rootScope.user;
    this.account = this._$rootScope.account;

    this._$scope.$on('realtime.updated.user', (event, user) => {
      this.user = user.resource;
    });

    this._$scope.$on('realtime.updated.account', (event, account) => {
      this.account = account.resource;
    });

    this._$scope.$on(EVENTS.ACCOUNT_LOADED, (event, account) => {
      this.account = account;
    });

    this.loadTrailDays();
  }

  loadTrailDays() {
    this.Subscription.get({
      include: 'plan',
    }).subscribe({
      next: (subscription) => {
        this.setTrailDays(subscription.trial_days_left);
      },
      error: () => {
        this.notify.error(null, 'An error occurred while loading subscription data.');
      },
    });
  }

  setTrailDays(trialDays) {
    this.days = trialDays;
  }

  getHelp() {
    if (angular.isDefined(window.Intercom)) {
      window.Intercom('showNewMessage');
    }
  }

  update() {
    this._$state.go('app.account.settings.account.plans');
  }
};

xplenty.component('onboardingToolbar', {
  controller: [
    '$element',
    '$translate',
    '$state',
    '$rootScope',
    '$scope',
    '$timeout',
    'notify',
    'Subscription',

    OnbordingToolbar,
  ],
  // eslint-disable-next-line global-require
  template: require('./onboarding-toolbar.html'),
  bindings: {
    // component: '<'
  },
});
